import players from "../jsonData/simulatorLineupData_ARG.json";
import shareImage from "../../../assets/selection-mx/seleccion-mx-share.jpg";
import teamImage from "../../../assets/selection-mx/team-mx.png";

export const lineupARGConfig = {
  players,
  title: "Arma tu 11 ideal de la selección de Argentina",
  accentColor: "var(--color-red)",
  pitchColor: ["#1a6b2e", "#155a26"],
  nameColor: "var(--color-black)",
  lastNameColor: "#75AADB",
  shareImage,
  teamImage,
  backgroundTeam: "#093f71ff",
  shareUrl: "futbol/mundial-2026/arma-tu-alineacion-de-argentina-para-el-mundial-2026-con-el-simulador-de-claro-sports/",
  shareText: "Mi 11 ideal de la Selección de Argentina ",
  shareTitle: "Mi 11 ideal de la Selección de Argentina ",
  shareFileName: "mi-11-ideal-arg.png",
  showClubToggle: false, // Mostrar botón para ver/ocultar club
  showNationalityToggle: false, // Mostrar botón para ver/ocultar nacionalidad
  selectionPath: "selection-arg", // Ruta de la carpeta de assets de la selección
  showFormationFilter: true, // Mostrar dropdown de alineación
  defaultFormation: "4-3-3", // Alineación por defecto
};